import React, {Component, createRef, Fragment} from 'react';

import '../../chat.css';
import Localization from '../../config/localization/Localization'
import ChatInputField from './chatInputField/ChatInputField';
import ChatAttachment from "./chatAttachment/ChatAttachment";
import ChatInputMenu from "./chatInputMenu/ChatInputMenu";
import IntegrationTypeEnum from "../../config/constants/IntegrationTypeEnum";
import {getLocalizationLanguageCode} from "../../util/localization";
import Autocomplete from "./autocomplete/Autocomplete";
import { debounce, removeHtmlTagsFromString} from "../../util/utilMethods";
import LayoutTypeEnum from "../../config/constants/LayoutTypeEnum";



/**
 * Class for the chat message input menu.
 */
class ChatInput extends Component {

    constructor(props) {
        super(props);
        this.inputRef = null;
        this.autoCompleteRef = createRef();
        this.handleGetTrainingPhraseListDebounced = debounce((searchText) => this.handleGetTrainingPhraseList(searchText), 200)
        this.state = {
            message: ''
        }
    }

    handleGetTrainingPhraseList = (searchText) => {
        this.props.handleGetTrainingPhraseList(searchText)
    }

    handleMessageChanges = (message) => {
        this.props.handleRootClick();
        this.setState({message: message}, () => {
            if(this.props.chatAgentMode){
                if(message.charAt(0) === "#" && message.length >= 3) {
                    const formattedSearchString = message.substring(1).trim().toLowerCase();
                    this.handleGetTrainingPhraseListDebounced(formattedSearchString)
                }
            } else if(this.props.chatConfig.enableAutocomplete){
                if(message.length >= 1) {
                    const formattedSearchString = message.trim().toLowerCase();
                    this.handleGetTrainingPhraseListDebounced(formattedSearchString)
                }
            }
        });
    };

    handleChangeFocusToInput = () => {
        //Textarea is burried in two divs, and therefore firstchild is used twice
        if(this.inputRef.firstChild && this.inputRef.firstChild.firstChild){
            this.inputRef.firstChild.firstChild.focus()
        }
    }

    handleEditChatAgentIntent = (intentId) => {
        this.props.handleGetChatResponse(intentId)
            .then((result) => {
                if(result != null && result.speechBubbleList != null){
                   let chatResponseString = '';
                   result.speechBubbleList.forEach((speechBubble, sbIndex) => {
                        if(speechBubble.messageList != null){
                            speechBubble.messageList.forEach((message, mIndex) => {
                                //Adds space between messages except first and last message
                                if(!(sbIndex === 0 && mIndex === 0)
                                    && !(sbIndex ===  result.speechBubbleList.length-1 && mIndex === speechBubble.messageList)) {
                                    chatResponseString += " ";
                                }
                                if(message.content != null) {
                                    const strippedString = removeHtmlTagsFromString(message.content)
                                    chatResponseString += strippedString
                                } else if(message.url != null){
                                    chatResponseString += message.url
                                }
                            })
                        }
                    })
                    this.setState({message: chatResponseString})
                    this.props.flushTrainingPhraseList();
                    this.handleChangeFocusToInput()
                }
            }).catch((e) => {
                console.log(e)
            })
    }

    handleSendChatAgentIntent = (intentId) => {
        const messageWasSent = this.props.sendChatAgentIntent(intentId);
        if(messageWasSent){
            this.setState({message: ''})
            this.props.flushTrainingPhraseList();
            this.handleChangeFocusToInput()
        }
    }

    handleSendMessage = () => {
        if (this.state.message.replace(/(<([^>]+)>)/ig, "").trim() !== '') {
            this.props.sendUserIsWriting(false);
            let messageWasSent = this.props.sendMessage(this.state.message, this.state.message);

            if (messageWasSent) {
                this.handleMessageChanges('');
            }
        }
    };

    handleSendUserSuggestion = (message) => {
        let messageWasSent = this.props.sendMessage(message, message);
        if (messageWasSent) {
            this.handleMessageChanges('');
            this.props.flushTrainingPhraseList();
            this.handleChangeFocusToInput()
        }
    }

    handleInputUpKeyStroke = () => {
        if(this.props.chatConfig.layoutMode === LayoutTypeEnum.chatBot && this.autoCompleteRef && this.autoCompleteRef.lastChild){
            this.autoCompleteRef.lastChild.focus()
        }
    }

    handleInputDownKeyStroke = () => {
        if(this.props.chatConfig.layoutMode === LayoutTypeEnum.searchBot && this.autoCompleteRef && this.autoCompleteRef.firstChild){
            this.autoCompleteRef.firstChild.focus()
        }
    }

    render() {
        const localizationCode = getLocalizationLanguageCode(this.props.language ? this.props.language.languageCode : null)
        return(
            <div id={'chat-input-container'} onClick={this.onClick}>
                {
                    this.props.disclaimer &&  <div id={'chat-disclaimer'} dangerouslySetInnerHTML={{__html: this.props.disclaimer}}/>
                }
                {(this.props.chatAgentMode || this.props.chatConfig.enableAutocomplete) && this.inputRef && this.props.language &&
                    <Autocomplete
                        chatAgentMode={this.props.chatAgentMode}
                        ref={(el) => this.autoCompleteRef = el}
                        anchorEl={this.inputRef}
                        searchString={this.state.message}
                        trainingPhraseList={this.props.trainingPhraseList}
                        flushTrainingPhraseList={this.props.flushTrainingPhraseList}
                        onEditChatAgentIntent={this.handleEditChatAgentIntent}
                        onSendChatAgentIntent={this.handleSendChatAgentIntent}
                        onSendUserSuggestion={this.handleSendUserSuggestion}
                        language={this.props.language}
                        onChangeFocusToInput={() => this.handleChangeFocusToInput()}
                        showAbove={this.props.chatConfig.layoutMode !== LayoutTypeEnum.searchBot}
                    />
                }
                <div id={'chat-show-error-container'} style={this.props.showConnectionLostMsg === false ? {display: 'none'} : null}>
                    {Localization[localizationCode]['chatInput.connectionProblems']}<br/>
                    {Localization[localizationCode]['chatInput.reconnecting']}
                </div>
                <div id={this.props.chatConfig.layoutMode === LayoutTypeEnum.searchBot ? 'search-bot-show-input-container' : 'chat-show-input-container'} ref={(div) => this.inputRef = div} style={{display: this.props.showConnectionLostMsg ? 'none' : ''}}>
                   <ChatInputField
                       language={this.props.language}
                       chatConfig={this.props.chatConfig}
                       chatAgentMode={this.props.chatAgentMode}
                       sendMessage={this.handleSendMessage}
                       stopMessage={this.props.stopMessage}
                       showStopMessage={  this.props.showStopMessage}
                       sendUserIsWriting={this.props.sendUserIsWriting}
                       handleMessageChanges={(value) => this.handleMessageChanges(value)}
                       message={this.state.message}
                       onInputUpKeyStroke={this.handleInputUpKeyStroke}
                       onInputDownKeyStroke={this.handleInputDownKeyStroke}
                       chatInputText ={this.props.chatInputText}
                       chatInputMax ={this.props.chatInputMax}
                   />
                    {!this.state.message ?
                        <Fragment>
                            {this.props.chatConfig && this.props.integrationType !== IntegrationTypeEnum.facebook && (this.props.chatConfig.enableUpload || this.props.chatAgentMode) ?
                                <ChatAttachment chatConfig={this.props.chatConfig}  language={this.props.language} uploadFileComplete={this.props.uploadFileComplete} setSnackbarErrorMessage={this.props.setSnackbarErrorMessage}/> : null}

                            {
                            this.props.chatConfig && this.props.language && this.props.chatConfig.showMenuInInput && this.props.chatConfig.chatMenuItemList.filter(cmi => cmi.languageId === this.props.language.id).length > 0 ?
                                <ChatInputMenu
                                    chatConfig={this.props.chatConfig}
                                    language={this.props.language}
                                    sendIntent={this.props.sendIntent}
                                    showAbove={this.props.chatConfig.layoutMode !== LayoutTypeEnum.searchBot}
                                    anchorEl={this.inputRef}
                                /> : null}
                        </Fragment> : null }
                </div>




            </div>
        );
    }
}

export default ChatInput;
